import Client from "./client/BookingAppClient";
import ClientCustomerInsight from './client/SavingLocationClient';

export default {
    registered(data) {
        return ClientCustomerInsight.post(`/api/customer/register-new`, data);
    }
};